<template>
  <div id="bst-wrap">
    <div class="l-project-wrap l-project-wrap--login">
      <!-- header -->
      <section class="l-content-area">
        <div class="l-content">
          <section class="p-bloc p-bloc--login">
            <div class="p-bloc__content l-wrap__outer">
              <div class="l-wrap__inner">
                <div class="login-box">
                  <div class="p-login__title">
                    <div class="logo"><img src="@/assets/img/login/logo.png" alt="hubsynch"></div>
                    <h1>{{ $t('TITLE_REMINDER_PAGE') }}</h1>
                  </div>

                  <!-- reminder -->
                  <section class="p-reminder">
                    <p v-html="$t('TEXT_REMINDER_COMPLETE')"></p>

                    <div class="p-reminder__finish">
                      <p v-html="$t('TEXT_REMINDER_COMPLETE_1')"></p>
                      <div class="c-btn c-btn--tologin"><a href="/login">{{ $t('LABEL_BUTTON_TO_LOGIN_PAGE') }}</a>
                      </div>
                    </div>
                  </section>

                </div><!-- .bg-box -->

              </div>
            </div>
          </section>


        </div><!-- .l-content -->
      </section><!-- .l-content-area -->

    </div><!-- .l-project-wrap -->

    <!-- footer -->

  </div>
</template>

<script setup>
</script>